/**
 * Product News Listing Vue App
 */

import { createApp } from 'vue';
import ProductNewsListing from './components/ProductNewsListing.vue';

document.addEventListener('DOMContentLoaded', () => {
	const container = document.getElementById('product-news-listing-app');

	if (!container) {
		return;
	}

	const app = createApp(ProductNewsListing);

	app.config.globalProperties.$wordpress = {
		ajaxUrl: window.jaeckleData?.ajaxUrl || '/wp-admin/admin-ajax.php',
		nonce: window.jaeckleData?.nonce || '',
	};

	app.mount('#product-news-listing-app');
});
